import { Divider, FormControl, HStack } from '@chakra-ui/react';
import * as React from 'react';
import { Controller } from 'react-hook-form';

import { SearchableTagsSelect } from '@/components/SearchableTagsSelect';
import {
  AttachmentButton,
  AttachmentPreview,
  Body,
  Container,
  ImageButton,
  ImagePreview,
  SponsoredPostSelector,
} from '@/components/post-form';
import { usePostFieldOptions } from '@/hooks/usePostFieldOptions';

export const AnswerForm: React.FC<{
  organizationId?: string;
  groupId?: string;
  originalImages?: { imageId: string; imageProxy: string }[];
  editing?: boolean;
}> = ({ organizationId, originalImages, editing }) => {
  const { showSponsoredPostOption, showTagsSelector } = usePostFieldOptions({
    organizationId: organizationId,
    editing,
  });

  return (
    <Container>
      <Body
        formLabel="Answer"
        validationMessage="An answer is required"
        placeholder="Write your answer"
      />
      <HStack>
        <ImageButton imageLimit={20} />
        <AttachmentButton attachmentLimit={10} />
      </HStack>
      <ImagePreview originalImages={originalImages} />
      <AttachmentPreview />

      {showSponsoredPostOption && organizationId && (
        <>
          <SponsoredPostSelector organizationId={organizationId} />
          <Divider />
        </>
      )}
      {showTagsSelector && (
        <FormControl>
          <Controller
            name="tags"
            render={({ field: { onChange, value, ref, onBlur } }) => (
              <SearchableTagsSelect
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                ref={ref}
              />
            )}
          />
        </FormControl>
      )}
    </Container>
  );
};
